import { createSlice } from "@reduxjs/toolkit";
import { getDoctorAppointmentsPatientsReducer } from "../../reducer/doctorAppointmentsPatients/doctorAppointmentsPatientsReducer";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const doctorAppointmentsPatientsSlice = createSlice({
  name: "doctorAppointmentsPatients",
  initialState,
  reducers: {
    resetDoctorAppointmentsPatients: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDoctorAppointmentsPatientsReducer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getDoctorAppointmentsPatientsReducer.fulfilled,
        (state, action) => {
          state.loading = false;
          state.data = action.payload;
        },
      )
      .addCase(
        getDoctorAppointmentsPatientsReducer.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        },
      );
  },
});

export const { resetDoctorAppointmentsPatients } =
  doctorAppointmentsPatientsSlice.actions;

export default doctorAppointmentsPatientsSlice.reducer;
